"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyShopService = void 0;
class AirwebTicketLegacyShopService {
    constructor(client) {
        this.client = client;
    }
    async getCatalog(query, options = {}) {
        const response = await this.client.http.get('shop/catalog', Object.assign(Object.assign({}, options), { params: query }));
        return response.data;
    }
}
exports.AirwebTicketLegacyShopService = AirwebTicketLegacyShopService;
//# sourceMappingURL=shop.service.js.map